import axios from "axios";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Text } from "components";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

function DeliveryChallanEdit() {

  const [visible, setVisible] = useState(true);
  let navigate = useNavigate();
  const { id } = useParams();

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const [erplist, setErplist] = useState([]);
  useEffect(() => {
    // Retrieving data from sessionStorage
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        // Parsing the JSON string to an array of objects
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);
  const showActionColumn = erplist.some(
    (item) => item.erp_module_id === 51 && item.update
  );

  const validationSchema = Yup.object().shape({
    remark: Yup.string().required("Remark  is required "),
  })


  const formik = useFormik({
    initialValues: {
      id: id,
      remark: ""

    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });

  const obj = { id: id };
  useEffect(() => {
    axios
      .post("/api/purple-fusion/delivarychallan/get", obj, headers)
      .then((response) => {
        const newData = response.data[0];
        console.log(newData);
        formik.setValues((prevValue) => {
          return {
            ...prevValue,
            ...newData,
          };
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);


  const handleFormSubmit = (value) => {
    console.log(value);
    axios
      .put("/api/purple-fusion/delivarychallan/update", value, headers)
      .then((response) => {
        console.log(response.data);
        const message = response.data.message;
        response.data.status
          ? toast.success(message, {
            autoClose: 1000,
            onClose: () => {
              setVisible(false);
              navigate(`/delivarychallan/list`);
            },
          })
          : toast.error(message, {
            autoClose: 1000,
          });
      })
      .catch((error) => {
        console.log(error);
        setVisible(false);
        navigate("*");
      });
  };

  const customStyle = {
    content: {
      width: "60%",
      height: "35%",
      margin: "auto",
      borderRadius: "10px",
    },
    overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
  };
  return (
    <>
      {" "}
      {showActionColumn ? (
        <div>
          <Modal
            isOpen={visible}
            onRequestClose={() => {
            }}

            style={customStyle}
          >
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-1 flex-col gap-[19px] justify-start md:px-5 w-full">
                <div className="flex flex-row w-[100%] mt-2 ml-2">
                  <div className="flex flex-row sm:gap-10 items-center justify-start w-full mt-0">
                    <Text
                      className="mt-[5px] md:text-xl sm:text-[24px] text-base text-black-900 tracking-[0.20px]"
                      size="txtInterMedium24"
                    >
                      Update Delivary Challan
                    </Text>
                  </div>
                  <div className="flex flex-row items-center justify-end mt-0">
                    <Button
                      className="cursor-pointer font-medium mb-1.5 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px] active:scale-90 transition-transform duration-200"
                      shape="round"
                      color="blue_A700"
                      size="base"
                      variant="fill"
                    >
                      Save
                    </Button>
                    <Button
                      className="cursor-pointer font-medium mb-3 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px]"
                      shape="round"
                      color="white"
                      size="base"
                      variant="fill"
                      se
                      onClick={() => {
                        setVisible(false);
                        navigate(`/delivarychallan/list`);
                      }}
                    >
                      ╳
                    </Button>
                  </div>
                </div>
                <div className="flex flex-col items-center justify-start md:ml-[0] ml-[25px] w-[87%] md:w-full mt-0">
                  <ToastContainer />

                  <div className="flex flex-row items-center justify-start  w-full">
                    <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                      <Text
                        className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                        size="txtInterMedium20Black700"
                      >
                        <span className="text-black-700 font-inter font-small text-sm">
                         Customer Name
                        </span>
                        <span className="text-red-A700 font-inter font-small">
                          *
                        </span>
                      </Text>
                      <input
                        name="remark"
                        type="text"
                        value={formik.values.customer_name}
                        readOnly
                        className="bg-gray-300 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full cursor-not-allowed"
                      ></input>
                     
                    </div>


                    <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full ml-7">
                      <Text
                        className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                        size="txtInterMedium20Black700"
                      >
                        <span className="text-black-700 font-inter font-small text-sm">
                          Remark
                        </span>
                        <span className="text-red-A700 font-inter font-small">
                          *
                        </span>
                      </Text>
                      <input
                        name="remark"
                        type="text"
                        value={formik.values.remark}
                        placeholder=" Enter Remark"
                        onChange={(e) => {
                          formik.handleChange(e);

                        }}
                        className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full"
                      ></input>
                      {formik.touched.remark &&
                        formik.errors.remark ? (
                        <div className="text-red-500 text-sm" >
                          {formik.errors.remark}
                        </div>
                      ) : null}
                    </div>


                  </div>
                </div>
              </div>
            </form>
          </Modal>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </>
  );
}

export default DeliveryChallanEdit;
